import { useAtomValue } from 'jotai'
import { useAtomCallback } from 'jotai/utils'
import { useCallback, type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'

import { isOpenShipmentOrderImportModalAtom } from '../../-states'

import { ShipmentOrderImportModalContent } from './ShipmentOrderImportModalContent'

type Props = {
  tenantKey: string
}

/**
 * 配送依頼インポートModal
 */
export const ShipmentOrderImportModal: FC<Props> = ({ tenantKey }) => {
  const isOpen = useAtomValue(isOpenShipmentOrderImportModalAtom)

  const handleClose = useAtomCallback(
    useCallback((_, set) => {
      set(isOpenShipmentOrderImportModalAtom, false)
    }, [])
  )

  return (
    <Modal
      title={MENU.IMPORTING_SHIPMENT_ORDER}
      width={580}
      open={isOpen}
      onCancel={handleClose}
    >
      <ShipmentOrderImportModalContent
        tenantKey={tenantKey}
        onSuccess={async () => handleClose()}
        onCancel={handleClose}
      />
    </Modal>
  )
}
